import isIGenesysFile from "./isIGenesysFile";
import { IGenesysFile } from "../interface/IMessage";

export default function getFileMediaType(uploadFile: IGenesysFile | File): string {
  if (isIGenesysFile(uploadFile)) {
    return uploadFile.mediaType;
  } else {
    return uploadFile.type;
  }
}
